module.exports = __webpack_public_path__ + "img/HZG_Logo_20_RGB.7b3a3a88.png";